import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../../helpers/axiosInstance";
import { toast } from "react-toastify";

const initialState = {
    exportData: [],
    loading: false,
    error: null,
};

export const getAuthenticationHistoryReport = createAsyncThunk(
    "authentication-history-export/get-report",
    async ({ user, searchParams }) => {
        try {
            const { url, endpoint } = user?.routesConfig;
            
            const base = url?.acsbackofficemanagement;
            const endpointpath = endpoint?.acsbackofficemanagement?.authenticationhistoryReport || "authenticationhistory/Report";
            
            const apiURL = base + endpointpath;

            const response = await axiosInstance.post(apiURL, searchParams);

            if(response?.data?.responseCode === '404') {
                toast.error(response?.data?.responseDescription);
            }

            return response?.data;
        } catch (error) {
            toast.error(error.response.data.message);
            throw error.response;
        }
    }
);

const authenticationHistoryExportSlice = createSlice({
    name: "authentication-history-export",
    initialState,
    reducers: {
        resetExportData: (state) => {
            state.exportData = [];
        }
    },
    extraReducers: (builder) => {
        builder
            // GET AUTHENTICATION HISTORY REPORT
            .addCase(getAuthenticationHistoryReport.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getAuthenticationHistoryReport.fulfilled, (state, action) => {
                state.loading = false;
                
                // Based on your API response, the data is directly in action.payload as an array
                let responseData;
                if (Array.isArray(action?.payload)) {
                    // Direct array response (your actual API structure)
                    responseData = action.payload;
                } else if (action?.payload?.data && Array.isArray(action.payload.data)) {
                    // Nested under data property
                    responseData = action.payload.data;
                } else if (action?.payload?.transactions && Array.isArray(action.payload.transactions)) {
                    // Nested under transactions property
                    responseData = action.payload.transactions;
                } else {
                    responseData = [];
                }
                
                state.exportData = responseData;
            })
            .addCase(getAuthenticationHistoryReport.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            });
    },
});

export const { resetExportData } = authenticationHistoryExportSlice.actions;

export default authenticationHistoryExportSlice.reducer;
